/* eslint-disable */
import DateInput from '../CustomControls/DateInput';
import Helper from '../helper';
import Validation from './Passenger.Validation';

const Passenger = {
  props:["passenger","viewModels","validationWatcher"],
  components:{
      DateInput,
  },
  updated(){
      //this.beingUsedAsContactInfoIndChanged();
      if (this.validationWatcher == true && this.allowNextValidation==true){
          this.getBirday();
          this.allowNextValidation = false;
          setTimeout(()=>{
              this.validation = Validation.validatePassengerBoxValue(this.passenger);
              this.passenger.validationPassed = this.validation.showAlert==false;
          },500);
          
      }else if (this.validationWatcher == false){
          this.allowNextValidation = true;
      }
      this.emitPassenger();
      
  },
  computed:{
      isMobile(){
          return Helper.display.isMobile(this.$vuetify.breakpoint.name);
      },
      meals(){
          return [];
      },
  },
  data(){
      return {
          allowNextValidation:true,
          validation:{
              showAlert:false,
              message:"",
          },
          titles:[],
          countries:[],
          emitters:{
              beingUsedAsContactInfoIndChanged:"beingUsedAsContactInfoIndChanged",
              emPassenger:"emPassenger",
              emValidationPassed:"emValidationPassed",
          },
          birthday:null,  

          rules: {
              required: value => !!value || 'Required.',
              email: value => {
                  return Helper.textFormatValidation.isEmail(value) || 'Invalid e-mail.'
              },
              azAZSpace: value => {return Helper.keypressFiltering.azAZSpace(value) ||
                'Invalid input'},
              azAZNumSpace: value => {return Helper.keypressFiltering
                .azAZNumSpace(value) ||'Invalid input'},
              counter50: value => value.length <=50 || 'Max 50 characters',
          },    
          helper:Helper,      
      }
  },
  watch:{
      passenger:function(val,oldVal){
      },
  },    
  methods:{
      beingUsedAsContactInfoIndChanged(){
          this.$emit(this.emitters.beingUsedAsContactInfoIndChanged,this.passenger);
      },
      decodePassengerType(passengerTypeCode){
          let passengerTypes = {ADT:"Adult", CNN:"Child", CHD:"Child", INF:"Infant", STU:"Student"};
          return passengerTypes[passengerTypeCode];
      },
      emitPassenger(){
          this.getBirday();
          this.$emit(this.emitters.emPassenger,this.passenger);  
      },
      getBirday(){
          if (this.birthday) {
              this.passenger.dobDay = this.birthday.day;
              this.passenger.dobMonth = this.birthday.month;
              this.passenger.dobYear = this.birthday.year;
          }
      },           
  },
};

export default Passenger;